import { ValidationError } from "sequelize"
import {
    MarkovModel,
    MarkovModelCreate,
    MarkovModelSave,
} from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, search, validate,
} from "client/store/utils"
import { LangType } from "client/store"
import {
    MarkovModelList,
    MarkovModelFilters,
    MarkovModelValidation,
} from "./types"


export const LoadAllMarkovModels = (accountId: number) => (
    GET(`/markovModel/accountId/${accountId}`)
    .then((models: MarkovModel[]) => {
        const modelList: MarkovModelList = {}
        models.forEach((model) => {
            modelList[model.id] = model
        })
        return modelList
    })
)

export const LoadMarkovModelById = (modelId: number, accountId: number) => (
    GET(`/markovModel/id/${modelId}/accountId/${accountId}`)
    .then((model: MarkovModel) => model)
)

export const SaveMarkovModel = (
    id: number,
    model: MarkovModelCreate,
    lang: LangType,
) => {
    const data: MarkovModelSave = {
        id,
        model,
    }
    return POST(
        "/markovModel/save",
        JSON.stringify(data),
    ).then((res) => {
        const newModel = res as MarkovModel
        const error = res as ValidationError

        return {
            newModelId: newModel.id || null,
            validation: <MarkovModelValidation>validate(error, lang),
        }
    })
}

export const DeleteMarkovModel = (modelId: number, accountId: number) => (
    DELETE(`/markovModel/delete/${modelId}/${accountId}`)
    .then((removedRows: number) => removedRows)
)

export const SortMarkovModels = (
    models: MarkovModel[],
    sortColumn: keyof MarkovModel,
    sortOrder: OrderType,
    filters: MarkovModelFilters,
) => {
    const modelsFiltered = models.filter((model) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, model)
        return showRow
    })
    modelsFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const modelIds: number[] = []
    modelsFiltered.forEach((model) => modelIds.push(model.id))

    return modelIds
}
